<div *ngIf="isShortTimeSettingMenu" class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_ORDER}}</div>
    <div class="us-right-item">
        <div class="d-flex" (click)="onDisplayOrderClick(CheckSheetDisplayOrder.Name)">
            <caremoni-radio-button
                [isChecked]="isDisplayOrderSelected(CheckSheetDisplayOrder.Name)"
                [disabled]="false"
                [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="0">
            </caremoni-radio-button>
            <label [ngClass]="{'disabled': false}" class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.SORT_NAME_NYUSHO}}</label>
        </div>
        <div class="d-flex" (click)="onDisplayOrderClick(CheckSheetDisplayOrder.StartTime)">
            <caremoni-radio-button
                [isChecked]="isDisplayOrderSelected(CheckSheetDisplayOrder.StartTime)"
                [disabled]="false"
                [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="1" [ydpad]="0">
            </caremoni-radio-button>
            <label [ngClass]="{'disabled': false}" class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.START_TIME_ORDER}}</label>
        </div>
        <div class="d-flex" (click)="onDisplayOrderClick(CheckSheetDisplayOrder.EndTime)">
            <caremoni-radio-button
                [isChecked]="isDisplayOrderSelected(CheckSheetDisplayOrder.EndTime)"
                [disabled]="false"
                [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="2" [ydpad]="0">
            </caremoni-radio-button>
            <label [ngClass]="{'disabled': false}" class="us-right-item-lable">{{CHECKSHEETSETTINGDIALOG.END_TIME_ORDER}}</label>
        </div>
    </div>
</div>
<div class="us-right-row">
    <div class="d-flex content-width" (click)="onCheckboxClick(SortType.hidden_overtime_flg)" >
        <caremoni-checkbox 
            [value]="hiddenOverTime"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="isShortTimeSettingMenu ? 1 : 0"
        ></caremoni-checkbox>
        <label for="checkbox2" class="ml-4 dlgu-txt">{{CHECKSHEETSETTINGDIALOG.HIDE_USERS_OUTSIDE}}</label>
    </div>
</div>
<div class="us-right-row">
    <div class="d-flex content-width" (click)="onCheckboxClick(SortType.hidden_leave_user)" >
        <caremoni-checkbox 
            [value]="hiddenLeaveUser"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="isShortTimeSettingMenu ? 2 : 1"
        ></caremoni-checkbox>
        <label for="checkbox2" class="ml-4 dlgu-txt">{{CHECKSHEETSETTINGDIALOG.HIDE_USERS_LEAVE}}</label>
    </div>
</div>

<div class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_UNIT_NYUSHO}}</div>
    <div class="d-flex">
        <caremoni-tv-multiselect [id]="'unit-multi-select'" [options]="displayUnits" [selectedValues]="unitSelected"
            (valueChange)="onChangeUnit($event)"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="isShortTimeSettingMenu ? 3 : 2">
        </caremoni-tv-multiselect>
    </div>
</div>
<div class="us-right-row">
    <div class="flex-fill">{{CHECKSHEETSETTINGDIALOG.DISPLAY_GROUP_NYUSHO}}</div>
    <div class="d-flex">
        <caremoni-tv-multiselect [id]="'group-multi-select'" [options]="displayGroups" [selectedValues]="groupSelected"
            (valueChange)="onChangeGroup($event)"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1"[xdpad]="0" [ydpad]="isShortTimeSettingMenu ? 4 : 3">
        </caremoni-tv-multiselect>
    </div>
</div>
